// extracted by mini-css-extract-plugin
export default {"noiseLevel":"NoizeValue_noiseLevel__z6rTX","stringValue":"NoizeValue_stringValue__4ay85","comma":"NoizeValue_comma__oROPA"};